import { UseCase } from './types';

// Wayfare is our own mock car rental service. It verifies over OpenID4VP and
// then issues the reservation back to the wallet, so it exercises bothcl
// directions in one flow.
export const wayfare: UseCase = {
    id: 'wayfare',
    url: 'https://wayfare.test.credenco.com/',
    // Identity check needs the Personal ID and the driving licence; the payment
    // step needs the bank account. Miss one and the flow stalls halfway.
    requiredCredentials: ['pid', 'rijbewijs', 'iban'],
    walkthrough: [
        {titleKey: 'steps.pick.title', bodyKey: 'steps.pick.body'},
        {titleKey: 'steps.verify.title', bodyKey: 'steps.verify.body'},
        {titleKey: 'steps.review.title', bodyKey: 'steps.review.body'},
        {titleKey: 'steps.pay.title', bodyKey: 'steps.pay.body'},
        {titleKey: 'steps.reservation.title', bodyKey: 'steps.reservation.body'},
        {titleKey: 'steps.pickup.title', bodyKey: 'steps.pickup.body'},
    ],
};
